import InputWithButton from '../../../../components/ReusableComponents/ManageHotel/InputWithButton/index'
import useCustomSearch from '../../../../hooks/useCustomSearch'

const TASearch = ({ value: TAUrl, setFormData, valid, hotelName, isDisabled }) => {
  const [openTA, closeTA] = useCustomSearch('TA', handleTAURL)

  function handleTAButtonClick() {
    openTA(hotelName)
  }

  function handleTAURL(url) {
    const [g, d] = /(g\d*)-(d\d*)/g.exec(url)
    const reviewTripAdvisorPage = `https://www.tripadvisor.com/UserReviewEdit-${g}-${d}`

    setFormData({
      reviewTripAdvisorPage
    })

    closeTA()
  }

  return (
    <InputWithButton
      label="TripAdvisor URL"
      buttonLabel="Find TA URL"
      value={TAUrl ? TAUrl.replace('https://', '') : ''}
      valid={valid}
      disabled
      buttonProps={{
        onClick: handleTAButtonClick,
        disabled: isDisabled || !hotelName
      }}
    />
  )
}

export default TASearch
